import React, { useEffect, useState } from "react";
import { Button, Checkbox, CheckboxProps, Col, Form, Input, message, Modal, Popconfirm, Row, Spin } from "antd";
import { useSecureRequest } from "../../hooks/useSecureRequest";
import { useCompany } from "../../contexts/CompanyContext";
import { useConfig } from "../../contexts/ConfigContext";
import { useStore } from "../../contexts/StoreContext";
import { EditOutlined } from "@ant-design/icons";
import { mutate } from "swr";

interface IformValues {
  id:number,
  name: string,
  alias: string
  company_id: number
  is_default: boolean
}
type TRequestData = {
  company: string | null,
  module: string,
  storehouse: IformValues,
  uidStorehouse?: string
}
function StoreModal(){
  const {store,updateStore} = useStore()
  const {company} = useCompany()
  const {config} = useConfig()
  const [form] = Form.useForm<IformValues>()
  const [loading, setLoading] = useState(false)
  const [edit, setEdit] = useState(false)
  const [messageApi, contextHolder] = message.useMessage();
  const currentData = !!store.current?.uid
  const {securePost} = useSecureRequest()

  useEffect(()=>{
    if(store.current){
      form.setFieldsValue(store.current)
    }else{
      form.resetFields()
    }
  },[store.current])

  const handleStore = async (values:IformValues) => {
    const foundById = store.list.some(el => el.alias === values.alias)
    if(foundById && !edit){
      return fail("Ya existe un registro con el identificador " + values.alias)
    }
    values.company_id = company.current.id
    if(store.list.length === 0){
      values.is_default = true
    }
    setLoading(true)
    let dataRequest:TRequestData = {
      company:company.current.uid,
      module: config.module,
      storehouse: values
    }
    let url = "/inventory/storehouse/create-storehouse"
    if(edit && currentData){
      dataRequest.uidStorehouse = store.current.uid
      dataRequest.storehouse.company_id = company.current.id
      dataRequest.storehouse.id = store.current.id
      url = "/inventory/storehouse/update-storehouse"
    }
    const storeResponse = await securePost(url,dataRequest)
    if(storeResponse.status === 200){
      mutate(key => Array.isArray(key) && key[0] === '/inventory/storehouse/get-storehouse/bulk', undefined, { revalidate: true })
      updateStore({showModal:false,current:undefined})
      form.setFieldsValue({})
      setEdit(false)
      success()
    }else{
      fail("Por favor intente nuevamente")
    }
    setLoading(false)
  }
  const success = () => {
    messageApi.open({
      type: 'success',
      content: 'Registro creado con éxito',
    });
  };
  const fail = (content:string) => {
    messageApi.open({
      type: 'error',
      content,
    });
  };

  const onClose = () => {
    updateStore({showModal:false,current:undefined})
    setEdit(false)
    form.resetFields()
    form.setFieldsValue({})
  }
  const footer = [
    <Popconfirm
      key="confirm"
      title="¿Estás seguro de realizar esta acción?"
      okButtonProps={{htmlType:"submit",form:"store-form"}}
      okText="Sí"
      cancelText="No"
    >
      <Button type="primary" disabled={!edit} htmlType="button">Actualizar</Button>
    </Popconfirm>,
    <Button 
      key="cancel" 
      type="default" 
      htmlType="button" 
      onClick={onClose}>Cancelar
    </Button>
  ]
  if(!currentData){
    footer[0] = <Popconfirm
      key="confirm"
      title="¿Estás seguro de realizar esta acción?"
      okButtonProps={{htmlType:"submit",form:"store-form"}}
      okText="Sí"
      cancelText="No"
    >
      <Button type="primary" htmlType="button">Crear</Button>
    </Popconfirm>
  }
  const onChange: CheckboxProps['onChange'] = (e) => {
    setEdit(e.target.checked);
  };
  return (
    <Modal
      title={<div style={{ textAlign: "center" }}>Datos de almacén</div>}
      open={store.showModal}
      maskClosable={false}
      confirmLoading={loading}
      onCancel={onClose}
      className="modal-responsive-md"
      destroyOnClose
      footer={footer}
      >
      <Spin size="large" tip="Procesando..." fullscreen spinning={loading} />
      {contextHolder}
      <Form
        form={form}
        name="store-form"
        layout="vertical"
        scrollToFirstError={{ block: 'end', focus: true }}
        style={{ maxWidth: '800px', margin: '0 auto'}}
        onFinish={handleStore}>
        {currentData && <Row gutter={[10,10]} style={{marginBottom:20}}>
          <Col span={24}>
            <Checkbox checked={edit} onChange={onChange}>
              <EditOutlined style={{ marginRight: 6 }} />
              Editar
            </Checkbox>
          </Col>
          <Col sm={12} xs={24}>
            <Form.Item
                label="Nombre"
                name={`name`}
                rules={[{ required: true, message: 'Ingrese un nombre valido'}]}
              >
                <Input placeholder="Almacén principal" type="text" disabled={!edit} minLength={3} maxLength={30}/>
              </Form.Item>
          </Col>
          <Col sm={12} xs={24}>
            <Form.Item
                label="Identificador"
                name={`alias`}
                rules={[{ required: true, message: 'Ingrese un identificador valido'}]}
              >
                <Input placeholder="ALMPPL" type="text" disabled minLength={3} maxLength={6}/>
              </Form.Item>
          </Col>
        </Row>}
        {!currentData && <Row gutter={[10,10]} style={{marginBottom:20}}>
          <Col sm={12} xs={24}>
            <Form.Item
                label="Nombre"
                name={`name`}
                rules={[{ required: true, message: 'Ingrese un nombre valido'}]}
              >
                <Input placeholder="Almacén principal" type="text" minLength={3} maxLength={30}/>
              </Form.Item>
          </Col>
          <Col sm={12} xs={24}>
            <Form.Item
                label="Identificador"
                name={`alias`}
                rules={[{ required: true, message: 'Ingrese un identificador valido'}]}
              >
                <Input placeholder="ALMPPL" type="text" minLength={3} maxLength={6}/>
              </Form.Item>
          </Col>
        </Row>}
      </Form>
    </Modal>
  )

}

export default StoreModal